







module.exports = {
  props: [ 'user', 'options' ]

  computed:
    user_name: ->
      return unless @user instanceof(User)
      if @options && @options.first_name
        @user.firstName()
      else
        @user.firstAndLastName()

    user_full_name: ->
      return '' unless @user instanceof(User)
      @user.firstAndLastName()
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/users/miniature.vue